export const CONFIRMATION_MODAL = 'CONFIRMATION_MODAL'
export const VERSION_MODAL = 'VERSION_MODAL'
export const VERSION_MODEL_MODAL = 'VERSION_MODEL_MODAL'
export const DOWNLOAD_SETTINGS = 'DOWNLOAD_SETTINGS'
export const TYPE_INFO = 'TYPE_INFO'
export const DELETE_DEVICE = 'DELETE_DEVICE'
